import React from 'react';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import Backdrop from '@material-ui/core/Backdrop';
import PatientsInfoForm from "./PatientsInfoForm";
import { isDefined } from "../../utils/utils";

type savePatientFnType = (value: any) => String | false | undefined;
type onCloseFnType = (value: boolean) => String | false | undefined;
type onAddFnType = (value: any) => String | false | undefined;
type onChangeFnType = (type: string, id: number, value: any) => String | false | undefined;
type onDeleteFnType = (valueEp: number, valueInt: number) => boolean | undefined;

interface IEpisodes {
    id: number;
    type: string;
    description: string;
    entrydate: Date;
    exitDate: Date | null;
    isClosed: boolean;
    room?: string;
    bed?: string;
    idIntern?: number;
    delete?: boolean;
}

interface IPatient {
    name: string;
    photoUri: string;
    identificationTypeId: number;
    identification: string;
    type: string;
    birthDate: Date;
    gender: string;
    career: string;
    nationality: string;
    clinicalHistory: string;
    episodes: IEpisodes[];
}

interface IPersonalUserInfoProps {
    showPatientInfoModal: boolean;
    onClose: onCloseFnType;
    savePatient: savePatientFnType;
    editMode: boolean;
    patientInfo: IPatient;
    onAddEpisodeToPatient: onAddFnType;
    saveInProgress: boolean;
    isLoading: boolean;
    onChangeEpisodesDate: onChangeFnType,
    identificationTypes: IIdentificationType[];
    onDeleteEpisode: onDeleteFnType;
}

interface IIdentificationType {
    id: number;
    type: string;
    description: string;
}

function DialogPatientsForm({
    showPatientInfoModal, onClose, savePatient, editMode, patientInfo, onAddEpisodeToPatient, saveInProgress, isLoading, onChangeEpisodesDate, identificationTypes, onDeleteEpisode
}: IPersonalUserInfoProps) {
    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState<DialogProps['scroll']>('paper');

    const descriptionElementRef = React.useRef<HTMLElement>(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    return (
        /* isDefined(userInfo) ? */
        <Dialog
            open={showPatientInfoModal}
            onClose={onClose}
            scroll={scroll}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            maxWidth="md"
            fullWidth={true}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
            disableBackdropClick //don't close modal when click outside
            disableEscapeKeyDown //don't close modal with ESC KEY
        >
            <PatientsInfoForm
                editMode={editMode}
                onClose={(isTouched) => onClose(isTouched)}
                savePatient={(v: any) => savePatient(v)}
                patientInfo={patientInfo}
                scroll={scroll}
                descriptionElementRef={descriptionElementRef}
                onAddEpisodeToPatient={onAddEpisodeToPatient}
                saveInProgress={saveInProgress}
                isLoading={isLoading}
                onChangeEpisodesDate={onChangeEpisodesDate}
                identificationTypes={identificationTypes}
                onDeleteEpisode={onDeleteEpisode}
            />
        </Dialog>
        /*  : <></> */
    );
}

export default DialogPatientsForm;